import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClose = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 32,
	height: 32,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m18.121 16 5.942-5.941A1.5 1.5 0 0 0 21.94 7.94L16 13.88 10.059 7.94A1.497 1.497 0 1 0 7.94 10.06L13.88 16 7.94 21.941a1.497 1.497 0 1 0 2.118 2.118L16 18.12l5.941 5.942a1.5 1.5 0 0 0 2.118-2.122Zm0 0",
		style: { fillOpacity: 1 }
	})
});
export default SvgClose;
